{
  "familyId": "MET-MEETK-CIRKEL-DEEL",
  "questions": [
    {
      "id": "MET-MEETK-CIRKEL-DEEL-001",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling beweert: \"Een sector van 90° is ⅓ van de cirkel, want 90 is een derde van 270.\" Wat klopt er niet aan deze redenering?",
      "options": ["De leerling deelt door 270 in plaats van door 360", "De leerling had door 180 moeten delen", "90° is altijd de helft van een cirkel", "De redenering van de leerling klopt wél"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":90,"highlightSector":true,"label":"Cirkelsector van 90°"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cirkelsector",
            "content": "Een hele cirkel = 360°. Het deel van de cirkel = hoek ÷ 360°. Dus 90° ÷ 360° = ¼.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_sector_deel",
      "variantIndex": 1,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De leerling maakt een fundamentele denkfout: hij deelt 90 door 270 in plaats van door 360. Een hele cirkel is altijd 360°, niet 270°. De leerling verwart het resterende deel (360° − 90° = 270°) met het geheel. De juiste berekening is: 90° ÷ 360° = ¼. Je kunt dit controleren: 4 × 90° = 360°, dus vier sectoren van 90° vullen precies een hele cirkel. Onthoud: bij het bepalen van een deel van de cirkel deel je altijd door het totaal (360°), nooit door de rest.",
        "solutionSteps": [
          "Analyseer de bewering: de leerling zegt 90 ÷ 270 = ⅓",
          "Identificeer de denkfout: de leerling deelt door 270 (het resterende deel), niet door 360 (het geheel)",
          "Pas de juiste methode toe: deel van cirkel = hoek ÷ 360°",
          "Bereken correct: 90° ÷ 360° = ¼",
          "Controleer: 4 × 90° = 360° — vier kwarten vullen precies de cirkel ✓"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling deelt door 270 (de rest van de cirkel) in plaats van door 360 (de hele cirkel). De juiste berekening is 90° ÷ 360° = ¼. De denkfout is: de leerling verwart 'de rest' met 'het geheel'.",
          "1": "Je dacht waarschijnlijk dat 180° het totaal is. Maar een halve cirkel = 180°, een hele cirkel = 360°. De fout van de leerling is dat hij door 270 deelt (de rest), niet door 360 (het geheel). Onthoud: deel altijd door 360°.",
          "2": "Je dacht waarschijnlijk dat 90° de helft is. Maar een halve cirkel = 180°, niet 90°. Een kwart cirkel = 90°, want 360° ÷ 4 = 90°. Onthoud: 90° = ¼ van 360°.",
          "3": "De redenering klopt niet. De leerling berekent 90 ÷ 270 = ⅓, maar had 90 ÷ 360 = ¼ moeten berekenen. De fout zit in het kiezen van het verkeerde totaal: 270° is de rest, 360° is het geheel."
        }
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-002",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de oppervlakte van een sector (hoek 60°, straal 6 cm) en schrijft: \"Oppervlakte = (60 ÷ 360) × 2 × π × 6 = 6,28 cm².\" Wat is de fout?",
      "options": ["De leerling gebruikt de omtrekformule (2πr) in plaats van de oppervlakteformule (πr²)", "De leerling deelt door 360 in plaats van door 180", "De leerling vergeet met 2 te vermenigvuldigen", "Er zit geen fout in de berekening"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":6,"sectorAngle":60,"highlightSector":true,"highlightRadius":true,"label":"Sector 60° met straal 6 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte cirkelsector",
            "content": "Oppervlakte sector = (hoek ÷ 360) × π × r². Hier: (60 ÷ 360) × π × 6² = ⅙ × π × 36 ≈ 18,85 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_sector_oppervlakte",
      "variantIndex": 2,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De leerling verwart twee fundamenteel verschillende formules: de omtrekformule (2 × π × r) en de oppervlakteformule (π × r²). Omtrek meet lengte (cm), oppervlakte meet vlak (cm²). De leerling berekent eigenlijk een deel van de omtrek (booglengte), niet de oppervlakte. De juiste berekening: (60 ÷ 360) × π × 6² = ⅙ × π × 36 ≈ 18,85 cm². Het verschil is groot: 6,28 cm (booglengte) vs. 18,85 cm² (oppervlakte). Onthoud: oppervlakte → πr² (kwadraat), omtrek → 2πr (geen kwadraat).",
        "solutionSteps": [
          "Analyseer de berekening van de leerling: (60 ÷ 360) × 2 × π × 6 — herken dat 2πr de omtrekformule is",
          "Identificeer de verwisseling: 2πr geeft omtrek (lengte in cm), πr² geeft oppervlakte (vlak in cm²)",
          "Pas de juiste formule toe: sectoroppervlakte = (hoek ÷ 360) × π × r²",
          "Bereken correct: (60 ÷ 360) × π × 36 = ⅙ × 113,10 ≈ 18,85 cm²",
          "Vergelijk: de leerling krijgt 6,28 cm (booglengte), het juiste antwoord is 18,85 cm² (oppervlakte)"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling gebruikt 2πr (omtrek) in plaats van πr² (oppervlakte). Het verschil: 2πr meet lengte, πr² meet vlak. Juist antwoord: ⅙ × π × 36 ≈ 18,85 cm².",
          "1": "Je dacht waarschijnlijk dat de fout in de deling zit. Maar 60 ÷ 360 = ⅙ is correct — dat is het juiste deel van de cirkel. De fout zit in de formule: 2πr is voor omtrek (lengte), πr² is voor oppervlakte (vlak).",
          "2": "Je dacht waarschijnlijk dat er een factor 2 mist. Maar het probleem is fundamenteler: de leerling gebruikt de verkeerde formule. 2πr is voor omtrek, πr² is voor oppervlakte. Het gaat niet om een ontbrekende factor.",
          "3": "Er zit wél een fout in: de leerling berekent ⅙ × 2π × 6 ≈ 6,28 cm (booglengte), maar de gevraagde oppervlakte is ⅙ × π × 36 ≈ 18,85 cm². De formules 2πr en πr² geven fundamenteel andere grootheden."
        }
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-003",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling snijdt een pizza in gelijke punten van 45°. Zijn vriend zegt: \"Dan heb je 6 punten, want 6 × 45 is bijna 360.\" Analyseer deze redenering. Hoeveel punten passen er precies?",
      "options": ["8 punten, want 360 ÷ 45 = 8 precies", "6 punten, de vriend heeft gelijk", "7 punten, want 7 × 45 = 315 en dat is het dichtst bij 360", "10 punten, want je moet afronden naar boven"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":45,"highlightSector":true,"label":"Pizzapunt van 45°"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel sectoren in een cirkel?",
            "content": "Aantal sectoren = 360° ÷ hoek per sector. De deling moet exact opgaan — je kunt geen halve punt snijden!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_sector_aantal",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De vriend maakt een rekenfout: 6 × 45 = 270, niet 360. De juiste berekening is 360 ÷ 45 = 8 precies. Je kunt dit controleren: 8 × 45 = 360 — het gaat exact op. Bij het verdelen van een cirkel in gelijke sectoren moet de deling altijd exact opgaan, anders passen de punten niet precies in de cirkel.",
        "solutionSteps": [
          "Analyseer de bewering van de vriend: 6 × 45 = 270, niet 360 — de vriend rekent fout",
          "Bereken correct: 360° ÷ 45° = 8 punten",
          "Controleer: 8 × 45 = 360 — gaat exact op ✓",
          "Conclusie: er passen precies 8 punten, niet 6"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De vriend rekent fout: 6 × 45 = 270 ≠ 360. De juiste berekening is 360 ÷ 45 = 8 punten, en 8 × 45 = 360 gaat exact op.",
          "1": "De vriend heeft ongelijk: 6 × 45 = 270, niet 360. Er ontbreken dan 90° (= 2 punten). Het juiste antwoord is 360 ÷ 45 = 8 punten. Onthoud: controleer door terug te vermenigvuldigen.",
          "2": "Je dacht waarschijnlijk dat je moet afronden naar het dichtstbijzijnde getal. Maar bij het verdelen van een cirkel moet de deling exact opgaan. 360 ÷ 45 = 8 precies, geen afronden nodig.",
          "3": "Je dacht waarschijnlijk dat je naar boven moet afronden. Maar 360 ÷ 45 = 8 precies — er is geen rest. 10 × 45 = 450, dat is meer dan 360°. Onthoud: controleer altijd met terugvermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-004",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling berekent de booglengte van een sector (hoek 120°, straal 9 cm) als volgt: \"120 ÷ 360 = ⅓. Dan ⅓ × π × 9² = ⅓ × 254,47 = 84,82 cm.\" Wat gaat er fout?",
      "options": ["De leerling gebruikt de oppervlakteformule (πr²) in plaats van de omtrekformule (2πr)", "De leerling deelt door 360 in plaats van door 180", "De leerling vergeet de straal te kwadrateren", "De berekening is correct"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":9,"sectorAngle":120,"highlightSector":true,"highlightRadius":true,"label":"Sector 120° met straal 9 cm"}}],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Booglengte",
            "content": "Booglengte = (hoek ÷ 360) × 2 × π × r. Hier: (120 ÷ 360) × 2 × 3,14 × 9 = ⅓ × 56,52 = 18,84 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_sector_booglengte",
      "variantIndex": 4,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "De leerling verwart booglengte met sectoroppervlakte — precies het omgekeerde van de veelgemaakte fout. Booglengte is een stuk van de omtrek (een lengte in cm), dus je gebruikt de omtrekformule 2πr. De leerling gebruikt πr² (de oppervlakteformule). De juiste berekening: ⅓ × 2 × π × 9 = ⅓ × 56,52 = 18,84 cm. Let op het verschil: 84,82 cm² (oppervlakte) vs. 18,84 cm (booglengte). De eenheid verraadt de fout: booglengte is in cm (lengte), niet cm² (vlak).",
        "solutionSteps": [
          "Analyseer de berekening: de leerling gebruikt πr² — herken dat dit de oppervlakteformule is",
          "Identificeer de verwisseling: booglengte = deel van omtrek → gebruik 2πr, niet πr²",
          "Pas de juiste formule toe: booglengte = (hoek ÷ 360) × 2 × π × r",
          "Bereken correct: ⅓ × 2 × π × 9 = ⅓ × 56,52 = 18,84 cm",
          "Controleer via eenheden: booglengte is in cm (lengte), de leerling krijgt cm² (vlak) — dat kan niet kloppen"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! De leerling gebruikt πr² (oppervlakte) in plaats van 2πr (omtrek). Booglengte = ⅓ × 2π × 9 = 18,84 cm. Tip: de eenheid verraadt de fout — booglengte is cm, niet cm².",
          "1": "Je dacht waarschijnlijk dat de fout in de deling zit. Maar 120 ÷ 360 = ⅓ is correct. De fout zit in de formule: πr² is voor oppervlakte (cm²), 2πr is voor booglengte (cm).",
          "2": "Je dacht waarschijnlijk dat de straal niet gekwadrateerd hoeft. Maar het probleem is juist het omgekeerde: de leerling kwadratéért de straal (πr²), terwijl booglengte 2πr gebruikt (zonder kwadraat). De leerling verwart oppervlakte met lengte.",
          "3": "De berekening is niet correct. De leerling berekent ⅓ × πr² ≈ 84,82 (sectoroppervlakte in cm²), maar de booglengte is ⅓ × 2πr = 18,84 cm. Onthoud: booglengte = deel × omtrek, sectoroppervlakte = deel × oppervlakte."
        }
      }
    },
    {
      "id": "MET-MEETK-CIRKEL-DEEL-005",
      "familyId": "MET-MEETK-CIRKEL-DEEL",
      "module": "Metriek",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_cirkelsector",
      "questionType": "multiple_choice",
      "question": "Een leerling zegt: \"Een sector van 72° is 1/4 van de cirkel, want 72 past 4 keer in 360 met een restje.\" Beoordeel deze redenering. Welk deel van de cirkel is een sector van 72° precies?",
      "options": ["1/5, want 360 ÷ 72 = 5 precies", "1/4, de leerling heeft gelijk", "1/6, want 72 ÷ 12 = 6", "2/10, want 72 is 20% van 360"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"sectorAngle":72,"highlightSector":true,"label":"Sector van 72°"}}],
      "data": null,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Deel van de cirkel",
            "content": "Deel = hoek ÷ 360°. Hier: 72 ÷ 360 = 72/360. Vereenvoudig: 72/360 = 1/5. Controleer: 5 × 72 = 360 — gaat exact op.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "cirkel_sector_breuk_analyse",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De leerling maakt een schattingsfout: hij zegt dat 72 'ongeveer 4 keer' in 360 past, maar rekent niet exact na. De juiste berekening: 360 ÷ 72 = 5 precies (niet 4 met een restje). Dus 72° = 1/5 van de cirkel. Je kunt dit controleren: 5 × 72 = 360° — het gaat exact op, er is geen 'restje'. De denkfout van de leerling is dat hij schat in plaats van deelt. Bij breuken van een cirkel moet de deling altijd exact opgaan.",
        "solutionSteps": [
          "Analyseer de bewering: de leerling zegt 72 past 4 keer in 360 met een restje",
          "Controleer: 4 × 72 = 288, niet 360 — er ontbreekt 72°, dat is geen 'restje' maar een hele sector",
          "Bereken exact: 360 ÷ 72 = 5 precies",
          "Vereenvoudig de breuk: 72/360 = 1/5 (deel door GGD 72)",
          "Controleer: 5 × 72° = 360° — vijf sectoren vullen precies de cirkel ✓"
        ],
        "distractorExplanations": {
          "0": "Goed geanalyseerd! 360 ÷ 72 = 5 precies, dus 72° = 1/5 van de cirkel. De leerling schatte '4 met een restje', maar 4 × 72 = 288 — er ontbreekt geen restje maar een hele sector van 72°.",
          "1": "De leerling heeft ongelijk: 4 × 72 = 288, niet 360. Er ontbreekt 72° — dat is geen klein restje maar een complete vijfde sector. 360 ÷ 72 = 5, dus het antwoord is 1/5.",
          "2": "Je dacht waarschijnlijk dat 72 ÷ 12 = 6 relevant is. Maar je moet 360 ÷ 72 berekenen (niet 72 ÷ 12). 360 ÷ 72 = 5, dus de sector is 1/5 van de cirkel.",
          "3": "2/10 = 1/5, dus de breuk klopt wél, maar de redenering '72 is 20% van 360' moet je controleren: 20% van 360 = 72 — dat klopt. Toch is 1/5 de eenvoudigste vorm. Het juiste antwoord is 1/5."
        }
      }
    }
  ]
}